<template lang="pug">
    .page
        //- Create Modal
        a-modal(v-model="addVisible" 
            title="创建交易账号" 
            @ok="handleCreateOk" 
            ok-text="创建"
            cancel-text="取消")
            a-form-model(:model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }")
                a-form-model-item(label="Name")
                    a-input(v-model="form.name")
                a-form-model-item(label="Account")
                    a-input(v-model="form.account")
                a-form-model-item(label="Broker")
                    a-input(v-model="form.broker")
                a-form-model-item(label="Host")
                    a-input(v-model="form.host")
                a-form-model-item(label="ClientId")
                    a-input(v-model="form.clientId")
                a-form-model-item(label="Desc")
                    a-input(v-model="form.desc")

        //- Edit Drawer
        a-drawer(:visible="editVisible" 
            title="编辑交易账号" 
            width="500"
            @close="editVisible=false"
        )
            a-form-model(:model="editForm" layout="vertical")
                a-form-model-item(label="Name")
                    a-input(v-model="editForm.name")
                a-form-model-item(label="Account")
                    a-input(v-model="editForm.account")
                a-form-model-item(label="Broker")
                    a-input(v-model="editForm.broker")
                a-form-model-item(label="Desc")
                    a-input(v-model="editForm.desc")
            
            a-button(type="primary" style="margin-top:20px" @click="submitEdit") 保存修改

        .ctl-bar
            a-button(type="primary" 
                @click="handleCreate" 
                style=" margin-right:20px") 
                a-icon(type="plus")
                span 创建

            a-button(type="primary" 
                style=" margin-right:20px" 
                @click="getData") 
                a-icon(type="redo")
                span 刷新

        a-table(:columns="columns", 
            size="small"
            :dataSource="items"
            :pagination="{ pageSize: 50 }"
            rowKey="_id")
            template(slot="action" slot-scope="record")
                a-popconfirm(title="确认删除该账号吗？" 
                    ok-text="确认" 
                    cancel-text="取消" 
                    @confirm="submitDelete(record._id)")
                    a.red 
                        a-icon(type="delete")
                a-divider(type="vertical")
                a(@click="handleEdit(record)") 
                    a-icon(type="edit")

            template(slot="expandedRowRender" slot-scope="record")
                TradeAccountUser(:id="record._id")

</template>

<script>
import TradeAccountUser from './TradeAccountUser.vue';

export default {
    data() {
        return {
            addVisible: false,
            editVisible: false,
            
            form: {
                name: '',
                account: '',
                broker: '',
                host: '',
                clientId: '',
                desc: ''
            },
            
            editForm: {
                _id: '',
                name: '',
                account: '',
                broker: '',
                desc: ''
            },

            columns: [
                {
                    title: 'ID',
                    dataIndex: '_id',
                },
                {
                    title: 'Name',
                    dataIndex: 'name',
                    sorter: (a, b) => a.name.localeCompare(b.name),
                },
                {
                    title: 'Account',
                    dataIndex: 'account',
                    sorter: (a, b) => (a.account || '').localeCompare(b.account || ''),
                },
                {
                    title: 'Broker',
                    dataIndex: 'broker',
                },
                {
                    title: 'Host',
                    dataIndex: 'host',
                },
                {
                    title: 'ClientId',
                    dataIndex: 'clientId',
                },
                {
                    title: 'Desc',
                    dataIndex: 'desc',
                },
                {
                    title: 'User Count',
                    dataIndex: 'userCount',
                    sorter: (a, b) => a.userCount - b.userCount,
                },
                {
                    title: 'Created At',
                    dataIndex: 'createdAt',
                    sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
                },
                {
                    title: 'Action',
                    scopedSlots: { customRender: 'action' },
                }
            ],
            items: [],
            users: []
        };
    },
    mounted() {
        this.getUsers();
        this.getData();
    },
    methods: {
        getUserName(id) {
             const u = this.users.find(u => u._id === id);
             return u ? u.name : id;
        },
        handleCreate() {
            this.form = {
                name: '',
                account: '',
                broker: '',
                host: '',
                clientId: '',
                desc: ''
            };
            this.addVisible = true;
        },
        handleCreateOk() {
            this.$api.request('POST', 'tradeAccount/create', this.form)
            .then(res => {
                this.$message.success('创建成功');
                this.addVisible = false;
                this.getData();
            });
        },
        handleEdit(record) {
            this.editForm = { ...record };
            this.editVisible = true;
        },
        submitEdit() {
            this.$api.request('POST', `tradeAccount/update`, this.editForm)
            .then(res => {
                this.$message.success('更新成功');
                this.editVisible = false;
                this.getData();
            });
        },
        submitDelete(id) {
            this.$api.request('DELETE', `tradeAccount/${id}`)
            .then(res => {
                this.$message.success('删除成功');
                this.getData();
            })
        },
        getData() {
            this.$api.request('GET', 'tradeAccounts')
            .then(res => {
                this.items = res.data.map(item => ({
                    ...item,
                    createdAt: new Date(item.createdAt).toLocaleString(),
                }));
            })
        },
        getUsers() {
            this.$api.request("GET", 'users')
            .then(res => {
                this.users = res.data;
            });
        }
    },
    components: {
        TradeAccountUser
    }
};
</script>

<style lang="less" scoped>
.ctl-bar {
    margin-bottom: 20px;
}
.user-list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    div {
        background: #f0f0f0;
        padding: 5px 10px;
        border-radius: 4px;
        margin-bottom: 5px;
    }
}
.red {
    color: red;
}
</style>